import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';

@Injectable()
export class MedicalServiceBatchPrintPageStore extends ComponentStoreV2Factory {

    public services = computed(() => {
        return this.globalGlobalStore.organizationStore.servicesInContext()
            .filter((it) => this.globalGlobalStore.isAllowedForService('voucher.read', it.id)());
    });

}

